export default {
      id: "sli-mic-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-mic",
      toString: function () {
        return this.url;
      }
    }